/* istanbul ignore file */
import React from 'react';
import PropTypes from 'prop-types';

import { TextField } from '@bingads-webui-react/fabric-control';
import { FilePicker as BackboneFilePicker } from '@bingads-webui/file-picker';
import { BackboneInstanceWrapper } from '@bingads-webui-react/backbone-instance-wrapper';

class CaptionPicker extends React.PureComponent {
  constructor(props) {
    super(props);

    const {
      i18n,
      showErrors,
    } = props;

    const filePickerOptions = {
      allowedFileExtensions: ['.srt'],
      i18n,
      isNative: false,
      displayFilePath: 'filename',
    };

    this.filePicker = new BackboneFilePicker(filePickerOptions);

    this.filePicker.on('validated', this.readFile);
    this.filePicker.on('error.extension', () => showErrors([
      <span>
        {i18n.getString('ImageExperience_Error_MediaFormatNotSupported')}
      </span>,
    ]));

    this.filePicker.render();
    this.filePicker.$('.remove-file').remove();
    this.filePicker.$('.file-text').hide();
  }

  readFile = () => {
    const {
      onFileRead,
    } = this.props;

    if (this.filePicker.fileObject) {
      onFileRead(this.filePicker.fileObject);
      this.filePicker.removeFile();
    } // else no media picked, so do nothing
  }

  render() {
    const {
      i18n,
      captionFile,
    } = this.props;

    return (
      <div className="upload-caption-file-container">
        <TextField
          placeholder={i18n.getString('ImageExperience_UploadCaptionFile_Placeholder')}
          value={captionFile ? captionFile.name : ''}
          readOnly
          className="file-picker-input"
        />
        <div className="file-picker-container">
          <div className="file-picker-react-wrapper">
            <BackboneInstanceWrapper
              instance={this.filePicker}
            />
          </div>
        </div>
      </div>
    );
  }
}

CaptionPicker.propTypes = {
  onFileRead: PropTypes.func.isRequired,
  captionFile: PropTypes.instanceOf(File),
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  showErrors: PropTypes.func.isRequired,
};

CaptionPicker.defaultProps = {
  captionFile: null,
};

export default CaptionPicker;
